(function() {
  document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".custom-reviews-container");
    if (!container) return;

    const reviews = document.querySelectorAll(".custom-review-card");
    const prevBtn = document.querySelector(".custom-reviews-prev-btn");
    const nextBtn = document.querySelector(".custom-reviews-next-btn");
    const section = document.querySelector(".custom-reviews-section");
    
    if (reviews.length === 0) return;
    
    // Determine max reviews based on screen size
    function getMaxReviewsPerSlide() {
      if (window.innerWidth >= 1024) {
        return 4; // Desktop
      } else if (window.innerWidth >= 768) {
        return 3; // Tablet
      } else {
        return 1; // Mobile
      }
    }
    
    let maxReviewsPerSlide = getMaxReviewsPerSlide();
    const totalReviews = reviews.length;
    
    // If total reviews is less than or equal to max per slide, hide navigation and exit
    if (totalReviews <= maxReviewsPerSlide) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    let currentIndex = 0;
    let autoSlideEnabled = container.getAttribute("data-auto-slide") === "true";
    let slideSpeed = parseInt(container.getAttribute("data-speed")) * 1000;

    function getSlideWidth() {
      const reviewCard = reviews[0];
      if (!reviewCard) return 0;
      
      const gap = window.innerWidth <= 767 ? 0 : 15;
      const containerWidth = container.offsetWidth;
      const maxReviews = getMaxReviewsPerSlide();
      
      if (maxReviews === 1) {
        return containerWidth;
      }
      
      const totalGap = gap * (maxReviews - 1);
      const exactCardWidth = (containerWidth - totalGap) / maxReviews;
      
      return exactCardWidth + gap;
    }

    function getTotalSlides() {
      const maxReviews = getMaxReviewsPerSlide();
      return Math.ceil(totalReviews / maxReviews);
    }

    function updateSlider() {
      const slideWidth = getSlideWidth();
      container.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
    }

    function nextSlide() {
      const totalSlides = getTotalSlides();
      if (currentIndex < totalSlides - 1) {
        currentIndex++;
      } else {
        currentIndex = 0;
      }
      updateSlider();
    }

    function prevSlide() {
      const totalSlides = getTotalSlides();
      if (currentIndex > 0) {
        currentIndex--;
      } else {
        currentIndex = totalSlides - 1;
      }
      updateSlider();
    }

    let autoSlide;
    
    function startAutoSlide() {
      if (autoSlideEnabled) {
        stopAutoSlide();
        autoSlide = setInterval(() => {
          nextSlide();
        }, slideSpeed);
      }
    }

    function stopAutoSlide() {
      clearInterval(autoSlide);
    }

    function resetAutoSlide() {
      stopAutoSlide();
      startAutoSlide();
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        nextSlide();
        resetAutoSlide();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        prevSlide();
        resetAutoSlide();
      });
    }

    if (container) {
      container.addEventListener("mouseenter", stopAutoSlide);
      container.addEventListener("mouseleave", startAutoSlide);
    }

    // Handle window resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newMaxReviews = getMaxReviewsPerSlide();
        const newTotalSlides = Math.ceil(totalReviews / newMaxReviews);
        
        // Adjust current index if needed
        if (currentIndex >= newTotalSlides) {
          currentIndex = newTotalSlides - 1;
        }
        
        updateSlider();
      }, 250);
    });

    // Touch events for mobile
    let touchStartX = 0;
    let touchEndX = 0;

    if (container) {
      container.addEventListener("touchstart", (e) => {
        touchStartX = e.touches[0].clientX;
      });

      container.addEventListener("touchend", (e) => {
        touchEndX = e.changedTouches[0].clientX;
        handleSwipe();
      });
    }

    function handleSwipe() {
      const swipeThreshold = 30;
      const swipeDistance = touchEndX - touchStartX;
      
      if (Math.abs(swipeDistance) > swipeThreshold) {
        if (swipeDistance < 0) {
          nextSlide();
        } else {
          prevSlide();
        }
        resetAutoSlide();
      }
    }

    // Initialize
    updateSlider();
    startAutoSlide();
    
    // Ensure proper width after fonts load
    window.addEventListener('load', function() {
      setTimeout(updateSlider, 100);
    });
  });
})();